import {
  IBasePagingRes,
  IBaseResponseModel,
} from "../../models/common/models.type";
import api from "../remote/baseApi";
import ApiEndpoints from "../remote/apiEndpoints";
import { envConfig } from "../../config/env.config";
import { EContentResponse, ESeoResponse } from "../../models/seo";
import { EBlogResponse, IBlogGetPage } from "../../models/blog";
import { EPageResponse, IPageGetPage } from "../../models/page";

const API = ApiEndpoints.PAGE;
const baseURL = envConfig.API_ENDPOINT;

const getPage = (
  data: IPageGetPage,
): Promise<IBasePagingRes<EPageResponse>> => {
  return api.get(baseURL, API.GetPage.url, {
    params: data,
  });
};

const getSingle = async (
  id: string,
): Promise<IBaseResponseModel<EBlogResponse>> => {
  return api.get(baseURL, API.GetSingle.url + "?id=" + id);
  //return res;
};

const create = async (
  data: EContentResponse,
): Promise<IBaseResponseModel<ESeoResponse>> => {
  return api.post(baseURL, API.Create.url, data);
  //return res;
};

const update = async (
  data: EContentResponse,
): Promise<IBaseResponseModel<ESeoResponse>> => {
  return api.put(baseURL, API.Update.url, data);
  //return res;
};

const deletes = async (
  id: string,
): Promise<IBaseResponseModel<ESeoResponse>> => {
  return api.delete(baseURL, API.Delete.url + "?id=" + id);
  //return res;
};

const PageService = {
  getPage,
  getSingle,
  create,
  update,
  deletes,
};

export default PageService;
